<template>
  <v-toolbar color="indigo" flat dark prominent class="adminToolbar">
    <div class="d-flex">
      <v-select
        v-model="search"
        :items="searchTypes"
        item-text="text"
        return-object
        flat
        solo-inverted
        attach
        label="Column"
        class="select-column"
      ></v-select>
      <v-text-field
        v-model="keyword"
        class="keyword"
        flat
        :label="label ? label : 'Search'"
        prepend-inner-icon="fa-search"
        solo-inverted
        @keydown.enter="add_condition"
      >
      </v-text-field>
    </div>

    <div class="chip_group">
      <v-chip 
        class="ma-2" 
        close 
        @click:close="remove_condition(i)" 
        v-for="(condition, i) in search_condition"
        :key="i"
      >
        {{ condition.text }}: {{ condition.display_keyword }}
      </v-chip>
    </div>
    <template v-slot:extension>
      <v-tabs v-model="tab">
        <v-tab v-for="tab in tabs" :key="tab.value" :value="tab">{{ tab.text }}</v-tab>
      </v-tabs>
      <v-menu offset-y content-class="sorting">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>fa-sort-amount-up</v-icon>
          </v-btn>
        </template>
        <v-btn-toggle v-model="sort" mandatory active-class="indigo darken-2 white--text" class="d-block">
          <v-btn v-for="sort in sortTypes" :key="sort.value" :value="sort" class="d-block" style="width: 100%">
            {{ sort.text }}
          </v-btn>
        </v-btn-toggle>
      </v-menu>
    </template>
  </v-toolbar>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  props: ['searchTypes', 'search_condition', 'sortTypes', 'sort', 'tabs', 'tab', 'label'],
  data() {
    return {
      search: {},
      keyword: '',
    }
  },
  created() {
    this.search = this.searchTypes[0]
  },
  computed: {
    ...mapState('global', ['clothes_types', 'seller_job_types']),
  },
  watch: {
    sort() {
      this.$emit('update:sort', this.sort)
      this.$emit('searching')
    },
    tab() {
      this.$emit('update:tab', this.tab)
      this.$emit('searching')
    },
    search_condition() {
      this.$emit('search_condition', this.search_condition)
      this.$emit('searching')
    }
  },
  methods: {
    add_condition() {
      let keyword = this.keyword
      if(this.search.column == 'job' && this.keyword) {
        let type = this.seller_job_types.find(type => {
          return type.name == this.keyword
        })
        keyword = type == undefined ? 99999 : [type.num, type.num]
      }
      else if(this.search.column == 'type' && this.keyword) {
        let type = this.clothes_types.find(type => {
          return type.name == this.keyword
        })
        keyword = type == undefined ? 99999 : [type.num, type.num]
      }
      this.search_condition.push({...this.search, keyword: keyword, display_keyword: this.keyword})
      this.keyword = ''
    },
    remove_condition(i) {
      this.search_condition.splice(i, 1)
    },
  }
}
</script>

<style lang="scss">
.adminToolbar {
  z-index: 5;
  height: unset !important;
  .select-column {
    max-width: 130px;
    margin-right: 10px;
  }
  .v-toolbar__content {
    display: block;
    z-index: 10;
    padding: 20px 30px 10px 30px;
    text-align: left;
    height: unset !important;
  }
  .keyword {
    .v-icon {
      font-size: 16px;
    }
  }
  .v-text-field__details {
    display: none;
  }
  .v-menu__content {
    .v-list-item__title {
        font-weight: 400 !important;
    }
  }
  .chip_group {
    min-height: 37px;
    .v-chip {
      background-color: white !important;
      color: black;
      margin: 5px 5px 0 5px !important;
      .v-icon {
        color: black;
      }
    }
  }
}
</style>